@if (showQuickFeedback() && isQuickFeedbackEnabled) {
    <!-- Step 1: Feedback Rating -->
    @if (currentStep() === 'rating') {
        <div class="feedback-container feedback-container--center" [@fadeSlideIn]>
            <h4 class="mb-2">How does this look?</h4>
            <div class="buttons">
                <button
                    class="btn-bx-secondary-stroked"
                    id="feedback-thumbs-up"
                    type="button"
                    aria-label="Give a thumbs up"
                    (click)="setFeedback(1)">
                    <span aria-label="thumbs up" class="emoji">👍</span>
                </button>
                <button
                    class="btn-bx-secondary-stroked"
                    id="feedback-thumbs-down"
                    type="button"
                    aria-label="Give a thumbs down"
                    (click)="setFeedback(0)">
                    <span aria-label="thumbs down" class="emoji">👎</span>
                </button>
            </div>
        </div>
    }

    <!-- Step 2: Feedback Text -->
    @if (currentStep() === 'feedback') {
        <div class="feedback-container feedback-container--left" [@fadeSlideIn]>
            <a id="dismiss-feedback" class="btn-flat dismiss" (click)="submitFeedback()"><i class="fa-light fa-xmark"></i></a>
            <h4 class="mb-3">Any other feedback?</h4>
            <textarea
                id="feedback-text"
                rows="3"
                placeholder="Please provide feedback"
                maxlength="1000"
                [(ngModel)]="feedbackText"></textarea>
            <button id="feedback-submit" class="btn-bx-primary mt-3" type="button" (click)="submitFeedback()">Submit</button>
        </div>
    }
}
